import { User_ManageComponent } from './User_Manage/User_Manage.component';
import { MigrationComponent } from './Migration/Migration/Migration.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { routes } from './routes';
import { DefaultModule } from './layouts/default/default.module';
import { LoginComponent } from './login/login.component';
import { ErrorComponent } from './error/error.component';
import { AuthService } from './_services/authService/auth.service';
import { ErrorInterceptor } from './_services/error.interceptor';
import { ToasterService } from './_services/Toaster.service';
import { DataTablesModule } from 'angular-datatables';
import { CommonModule } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
// import { ChartsModule } from 'ng2-charts';
// import { ChartistModule} from 'ng-chartist';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ErrorComponent

  ],
  imports: [
    BrowserModule,
    // ChartistModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    RouterModule.forRoot(routes),
    DefaultModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })

  ],
  providers: [
    AuthService,
    ErrorInterceptor,
    ToasterService
    ],
  bootstrap: [AppComponent],
})
export class AppModule {}
